import { PlusOutlined } from '@icon';
import { Button, Empty } from '@ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface AlertsEmptyProps {
  onAddClick: () => void;
}

const AlertsEmpty: React.FC<AlertsEmptyProps> = ({ onAddClick }) => {
  return (
    <>
      <Empty
        title={<FormattedMessage id="alerts.empty_title" />}
        description={<FormattedMessage id="alerts.empty_copy" />}
        style={{ padding: 40 }}
      >
        <Button Icon={PlusOutlined} onClick={onAddClick}>
          Vytvorenie oznamu
        </Button>
      </Empty>
    </>
  );
};

export default AlertsEmpty;
